import React from 'react';
import Form from 'react-bootstrap/Form';
import Styles from './Header.module.scss';

const Header = ({ isChecked, handleToggleClick }) => {
  return (
    <div className={Styles.outerContainer__card}>
      <div className={Styles.outerContainer__card__left}>
        <h2>Pricing Plans</h2>
      </div>
      <div className={Styles.outerContainer__card__right}>
        <div
          className={`${Styles.outerContainer__card__right__toggleContainer} ${isChecked ? Styles.yearly : ''}`}
        >
          <span
            className={!isChecked ? Styles.active : ''}
            onClick={() => handleToggleClick()}
          >
            Monthly
          </span>
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              label=""
              className={Styles.outerContainer__card__right__switch}
              checked={isChecked}
              onChange={handleToggleClick}
            />
          </Form>
          <span
            className={isChecked ? Styles.active : ''}
            onClick={() => handleToggleClick()}
          >
            Yearly
          </span>
        </div>
        <div className={Styles.outerContainer__card__right__badge}>
          Save up to 70% with our special yearly offer
        </div>
      </div>
    </div>
  );
};

export default Header;
